import React, { useState, useEffect } from 'react';
import { View, Modal, Text, TouchableOpacity } from 'react-native';
import { styles } from '../common/styles'; 
import { i18n } from '../common/localization'; // Importiamo i18n

export const DatePickerComponent = ({ open, date, onConfirm, onCancel }) => {
    const [selectedDate, setSelectedDate] = useState(date || new Date());
    const [displayDate, setDisplayDate] = useState(date || new Date());

    useEffect(() => {
        if (open && date) {
            setSelectedDate(new Date(date));
            setDisplayDate(new Date(date));
        }
    }, [open, date]);

    if (!open) return null;

    // --- RECUPERO TRADUZIONI ---
    // Usiamo Object.values per sicurezza, nel caso i18n ritorni un oggetto {0: "Lun", 1: "Mar"...}
    const rawMonths = i18n.t("months");
    const months = Array.isArray(rawMonths) ? rawMonths : Object.values(rawMonths);

    const rawDays = i18n.t("daysShort");
    const daysShort = Array.isArray(rawDays) ? rawDays : Object.values(rawDays);

    const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
    
    const getFirstDayOfMonth = (year, month) => {
        const day = new Date(year, month, 1).getDay();
        return day === 0 ? 6 : day - 1; 
    };

    const changeMonth = (increment) => {
        const newDate = new Date(displayDate);
        newDate.setMonth(newDate.getMonth() + increment);
        setDisplayDate(newDate);
    };

    const handleDayPress = (day) => {
        const newDate = new Date(displayDate.getFullYear(), displayDate.getMonth(), day);
        setSelectedDate(newDate);
    };

    const renderCalendar = () => {
        const year = displayDate.getFullYear();
        const month = displayDate.getMonth();
        const daysInMonth = getDaysInMonth(year, month);
        const firstDay = getFirstDayOfMonth(year, month);
        const rows = [];
        let cells = [];

        for (let i = 0; i < firstDay; i++) {
            cells.push(<View key={`empty-${i}`} style={styles.datePicker.dayCell} />);
        }

        for (let day = 1; day <= daysInMonth; day++) {
            const isSelected = selectedDate.getDate() === day && 
                               selectedDate.getMonth() === month && 
                               selectedDate.getFullYear() === year;
            cells.push(
                <TouchableOpacity 
                    key={day} 
                    style={[styles.datePicker.dayCell, isSelected && styles.datePicker.selectedDayCell]} 
                    onPress={() => handleDayPress(day)}
                >
                    <Text style={[styles.datePicker.dayText, isSelected && styles.datePicker.selectedDayText]}>{day}</Text>
                </TouchableOpacity>
            );
            if (cells.length === 7) {
                rows.push(<View key={day} style={styles.datePicker.weekRow}>{cells}</View>);
                cells = [];
            }
        }
        if (cells.length > 0) {
            while (cells.length < 7) cells.push(<View key={`empty-end-${cells.length}`} style={styles.datePicker.dayCell} />);
            rows.push(<View key="last-row" style={styles.datePicker.weekRow}>{cells}</View>);
        }
        return rows;
    };

    return (
        <Modal transparent={true} visible={open} animationType="fade" onRequestClose={onCancel}>
            <View style={styles.centeredView}>
                
                <TouchableOpacity style={styles.datePicker.backdrop} onPress={onCancel} activeOpacity={1} />
                
                <View style={styles.datePicker.modalContainer}>
                    
                    <View style={styles.datePicker.header}>
                        <TouchableOpacity onPress={() => changeMonth(-1)} style={styles.datePicker.arrowBtn}>
                            <Text style={styles.datePicker.arrowText}>{"<"}</Text>
                        </TouchableOpacity>
                        <Text style={styles.datePicker.headerTitle}>
                            {/* Nome Mese Tradotto + Anno */}
                            {months[displayDate.getMonth()]} {displayDate.getFullYear()}
                        </Text>
                        <TouchableOpacity onPress={() => changeMonth(1)} style={styles.datePicker.arrowBtn}>
                            <Text style={styles.datePicker.arrowText}>{">"}</Text>
                        </TouchableOpacity>
                    </View>

                    <View style={styles.datePicker.weekHeader}>
                        {daysShort.map((day, index) => (
                            <Text key={index} style={styles.datePicker.weekDayText}>{day}</Text>
                        ))}
                    </View>

                    <View style={styles.datePicker.calendarBody}>
                        {renderCalendar()}
                    </View>

                    <View style={styles.datePicker.footer}>
                        <TouchableOpacity onPress={onCancel} style={styles.datePicker.footerBtn}>
                            <Text style={styles.datePicker.cancelText}>{i18n.t("cancel")}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={() => onConfirm(selectedDate)} style={styles.datePicker.confirmBtn}>
                            <Text style={styles.datePicker.confirmText}>{i18n.t("confirm").toUpperCase()}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
        </Modal>
    );
};